module.exports = __webpack_public_path__ + "img/f7bafd9a5bd27bd2dced58c532e69b73.f7bafd9a.png";